import { SitemapItem } from './sitemap-item'

export class SmartAppItem extends SitemapItem {
  public appName: string
  public msProvider: string

  constructor(model: SmartAppItem) {
    super(model)
    this.appName = model.appName
    this.msProvider = model.msProvider
  }
}
